import * as selectors from './selectors'

export const contractSelectors = selectors
